import { CenterOnOffPilot, DonorShieldStatus } from '../../enums/index';
import { IUnosData, IInsuranceCarrierInfo } from './';
import { ISerologyTest } from '../serology-test';

export interface IUpdateCenterRequest {
    id: number,
    alias: string,
    betaActivationStatus: CenterOnOffPilot;
    dashDomain: string;
    excludeDataCompliance: boolean;
    userName: string;
    password: string;
    monthlyFee: number;
    nkrFee: string;
    annualFee: number;
    dcnAnnualFee: number;
    dashFee: number;
    isAcceptingReferrals: boolean;
    nddReferrals: number;
    isDeleted: boolean;
    isNkrParticipant: boolean;
    transplantStatus: boolean;
    transplantRestartDate: string;
    isAllowedLocalCryo: boolean;
    isRdnParticipant: boolean;
    isMedicalBoard: boolean;
    reduceEmails: boolean;
    isUtilizing3gKidneyForLife: boolean;
    hasAgreedToFees: boolean;
    isAllIn: boolean;
    isAdpPartner: boolean;
    isAdpParticipant: boolean;
    isDcnParticipant: boolean;
    isFamilyVoucherParticipant: boolean;
    isMicrositeParticipant: boolean;
    isAccParticipant: CenterOnOffPilot;
    hasCenterBilling: boolean;
    useMicrositeResponsibilityConfirmation: boolean;
    isDppParticipant: boolean;
    isStreamlinedBilling: boolean;
    isFollowUpParticipant: boolean;
    isDashLiverParticipant: boolean;
    isInDonorShield: DonorShieldStatus;
    isGoldStar: boolean;
    isInListingService: boolean;
    isPrivate: boolean;
    hasGraftSurvivalFile: boolean;
    dcAdultGraftSurvival1: number;
    dcAdultGraftSurvival3: number;
    dcPediatricGraftSurvival1: number;
    dcPediatricGraftSurvival3: number;
    adultGraftSurvival1: number;
    adultGraftSurvival3: number;
    pediatricGraftSurvival1: number;
    pediatricGraftSurvival3: number;
    dcAdultPatientSurvival1: number;
    dcAdultPatientSurvival3: number;
    dcPediatricPatientSurvival1: number;
    dcPediatricPatientSurvival3: number;
    adultPatientSurvival1: number;
    adultPatientSurvival3: number;
    pediatricPatientSurvival1: number;
    pediatricPatientSurvival3: number;
    sRTRSourceDate: string;
    centerUnosData: IUnosData[];
    webUrl: string;
    name: string;
    opoId: number;
    earliestOrganPickupTime: string;
    latestOrganPickupTime: string;
    timezone: string;
    avgCostLDEvalWorkup: number;
    doesOpoPackorPerf: number;
    opoCostPackAndPerf: number;
    achRoutingNumber: string;
    achAccountNumber: string;
    streamlinedHospitalBilling: boolean;
    physicianDonorNephrectomyCharges: number;
    provideSwapChecklists: boolean;
    hasFrozenExploratory: boolean,
    hasFrozenScreening: boolean,
    xmVirtualOption: number,
    labLavender85: number,
    labLavender40: number,
    labLavender70: number,
    labLavender100: number,
    labPink60: number,
    labPink100: number,
    labRed70: number,
    labRed100: number,
    labGreen100: number,
    labYellow85: number,
    transLavender85: number,
    transLavender40: number,
    transLavender70: number,
    transLavender100: number,
    transPink60: number,
    transPink100: number,
    transRed70: number,
    transRed100: number,
    transGreen100: number,
    transYellow85: number,
    performsIncompatibleTransplants: number,
    performsDesensitization: number,
    performsNonSteroidProtocol: number,
    maxPairWorkups?: number,
    minNDDAge?: number,
    providesDonorInsurance: number,
    donorWorkupWait?: number,
    recipWorkupWait?: number,
    maxNDDAge?: number,
    centerInsuranceCarrierInfo: IInsuranceCarrierInfo[];
    pcrTestHour: number;
    serologyMaxDaysBeforeSurgery: number,
    serologyTurnaround: number,
    isSerologyParticipant: number,
    requiresQfg: number,
    serologyShipToId: number,
    serologyTests: ISerologyTest[]
}